import styled from 'styled-components';

export const StyledLabel = styled.label`
  margin: 20px 0 10px;
`;

export const ModalFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 600px;
  min-width: 300px;
  padding: 0px;
  max-height: 80vh;
  overflow-y: auto;

  /* The modal sizes to its content from tablet up. Field messages break the form's inline
     labels and inputs into short lines, which narrowed the dialog; a set width keeps it the
     same with or without them (100px is the modal's own margin and padding). */
  ${({ theme }) => theme.media.tabletPortraitUp`
    width: min(600px, calc(100vw - 100px));
  `}
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ theme }) => theme.media.tabletPortraitUp`
    flex-direction: row;
    gap: 15px;
  `}
`;

export const InputItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const CollapsibleSection = styled.div`
  overflow: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  max-height: ${({ $visible }) => ($visible ? '500px' : '0')};
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  margin: 10px 0;
  background: #f0fdf4;
  border-radius: 8px;
  color: #166534;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  max-height: ${({ $visible }) => ($visible ? '100px' : '0')};
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  padding: ${({ $visible }) => ($visible ? '0.75rem 1rem' : '0 1rem')};
  margin: ${({ $visible }) => ($visible ? '10px 0' : '0')};
  transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out, padding 300ms ease-in-out, margin 300ms ease-in-out;

  svg {
    flex-shrink: 0;
  }
`;
